/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesAddTaskToPlanningEntryRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesAssignTaskToEmployeesRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksResponse,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesChangePlaningEntryTypeRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesCreatePlanningEntryRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesDuplicatePlanningEntryRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesMoveTaskToPlanningEntryRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlannedVehicleDto,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlannedVehicleRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlanningEntryStartPointRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryRequest,
  FacilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryTaskRequest,
  GetApiV1PlanningEntriesParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPlanningEntries = () => {
/**
 * @summary Get all planning entries with optional filters
 */
const getApiV1PlanningEntries = (
    params?: GetApiV1PlanningEntriesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryListDto[]>(
      {url: `/api/v1/planning/entries`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new planning entry
 */
const postApiV1PlanningEntries = (
    facilityFlowCoreModulesPlanningDtosPlanningEntriesCreatePlanningEntryRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesCreatePlanningEntryRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>(
      {url: `/api/v1/planning/entries`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesCreatePlanningEntryRequest
    },
      options);
    }
  const putApiV1PlanningEntries = (
    facilityFlowCoreModulesPlanningDtosPlanningEntriesChangePlaningEntryTypeRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesChangePlaningEntryTypeRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>(
      {url: `/api/v1/planning/entries`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesChangePlaningEntryTypeRequest
    },
      options);
    }
  /**
 * @summary Get a single planning entry by ID with all task details
 */
const getApiV1PlanningEntriesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>(
      {url: `/api/v1/planning/entries/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing planning entry (change to absence, adjust times, etc.)
 */
const putApiV1PlanningEntriesId = (
    id: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>(
      {url: `/api/v1/planning/entries/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryRequest
    },
      options);
    }
  /**
 * @summary Delete a complete planning entry (including all tasks)
 */
const deleteApiV1PlanningEntriesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Plan the vehicle and driver role of a work day in advance (FACF-118). Send both as null
to clear. The vehicle stamped at clock-in still wins.
 */
const putApiV1PlanningEntriesIdVehicle = (
    id: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlannedVehicleRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlannedVehicleRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlannedVehicleDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlannedVehicleDto>(
      {url: `/api/v1/planning/entries/${id}/vehicle`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlannedVehicleRequest
    },
      options);
    }
  /**
 * @summary Override where the employee's work day starts for the planning assistant (instead of the
home location). WorkDay entries only; latitude −90..90, longitude −180..180.
 */
const putApiV1PlanningEntriesIdStartPoint = (
    id: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlanningEntryStartPointRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlanningEntryStartPointRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}/start-point`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesSetPlanningEntryStartPointRequest
    },
      options);
    }
  /**
 * @summary Remove the start point override; the planning assistant falls back to home / first object.
 */
const deleteApiV1PlanningEntriesIdStartPoint = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}/start-point`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Add a task to an existing planning entry
 */
const postApiV1PlanningEntriesIdTasks = (
    id: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesAddTaskToPlanningEntryRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesAddTaskToPlanningEntryRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}/tasks`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesAddTaskToPlanningEntryRequest
    },
      options);
    }
  /**
 * @summary Plan one task for several employees on the same day. Every employee needs a planned
work day on that date; either all get the task or none (FACF-111).
 */
const postApiV1PlanningEntriesTasksAssign = (
    facilityFlowCoreModulesPlanningDtosPlanningEntriesAssignTaskToEmployeesRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesAssignTaskToEmployeesRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/tasks/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesAssignTaskToEmployeesRequest
    },
      options);
    }
  /**
 * @summary Remove a task from a planning entry
 */
const deleteApiV1PlanningEntriesIdTasksTaskId = (
    id: string,
    taskId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}/tasks/${taskId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Update a specific task's time or sequence within a planning entry
 */
const putApiV1PlanningEntriesIdTasksTaskId = (
    id: string,
    taskId: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryTaskRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryTaskRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/${id}/tasks/${taskId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesUpdatePlanningEntryTaskRequest
    },
      options);
    }
  /**
 * @summary Duplicate an existing planning entry to a new date (perfect for recurring tasks)
 */
const postApiV1PlanningEntriesIdDuplicate = (
    id: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesDuplicatePlanningEntryRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesDuplicatePlanningEntryRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesPlanningEntryDto>(
      {url: `/api/v1/planning/entries/${id}/duplicate`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesDuplicatePlanningEntryRequest
    },
      options);
    }
  /**
 * @summary Bulk update all future instances of a task for an employee
Frontend use case: "Apply changes to all future same tasks"
 */
const putApiV1PlanningEntriesTasksBulkUpdate = (
    facilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksResponse>(
      {url: `/api/v1/planning/entries/tasks/bulk-update`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesBulkUpdateTasksRequest
    },
      options);
    }
  const postApiV1PlanningEntriesTasksPlanningEntryTaskIdMove = (
    planningEntryTaskId: string,
    facilityFlowCoreModulesPlanningDtosPlanningEntriesMoveTaskToPlanningEntryRequest: FacilityFlowCoreModulesPlanningDtosPlanningEntriesMoveTaskToPlanningEntryRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/planning/entries/tasks/${planningEntryTaskId}/move`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosPlanningEntriesMoveTaskToPlanningEntryRequest
    },
      options);
    }
  return {getApiV1PlanningEntries,postApiV1PlanningEntries,putApiV1PlanningEntries,getApiV1PlanningEntriesId,putApiV1PlanningEntriesId,deleteApiV1PlanningEntriesId,putApiV1PlanningEntriesIdVehicle,putApiV1PlanningEntriesIdStartPoint,deleteApiV1PlanningEntriesIdStartPoint,postApiV1PlanningEntriesIdTasks,postApiV1PlanningEntriesTasksAssign,deleteApiV1PlanningEntriesIdTasksTaskId,putApiV1PlanningEntriesIdTasksTaskId,postApiV1PlanningEntriesIdDuplicate,putApiV1PlanningEntriesTasksBulkUpdate,postApiV1PlanningEntriesTasksPlanningEntryTaskIdMove}};
export type GetApiV1PlanningEntriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['getApiV1PlanningEntries']>>>
export type PostApiV1PlanningEntriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['postApiV1PlanningEntries']>>>
export type PutApiV1PlanningEntriesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntries']>>>
export type GetApiV1PlanningEntriesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['getApiV1PlanningEntriesId']>>>
export type PutApiV1PlanningEntriesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntriesId']>>>
export type DeleteApiV1PlanningEntriesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['deleteApiV1PlanningEntriesId']>>>
export type PutApiV1PlanningEntriesIdVehicleResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntriesIdVehicle']>>>
export type PutApiV1PlanningEntriesIdStartPointResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntriesIdStartPoint']>>>
export type DeleteApiV1PlanningEntriesIdStartPointResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['deleteApiV1PlanningEntriesIdStartPoint']>>>
export type PostApiV1PlanningEntriesIdTasksResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['postApiV1PlanningEntriesIdTasks']>>>
export type PostApiV1PlanningEntriesTasksAssignResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['postApiV1PlanningEntriesTasksAssign']>>>
export type DeleteApiV1PlanningEntriesIdTasksTaskIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['deleteApiV1PlanningEntriesIdTasksTaskId']>>>
export type PutApiV1PlanningEntriesIdTasksTaskIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntriesIdTasksTaskId']>>>
export type PostApiV1PlanningEntriesIdDuplicateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['postApiV1PlanningEntriesIdDuplicate']>>>
export type PutApiV1PlanningEntriesTasksBulkUpdateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['putApiV1PlanningEntriesTasksBulkUpdate']>>>
export type PostApiV1PlanningEntriesTasksPlanningEntryTaskIdMoveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPlanningEntries>['postApiV1PlanningEntriesTasksPlanningEntryTaskIdMove']>>>
